import styles from "./MarketPlaceDetail.module.css";
import { useState } from "react";
import UnitPriceForm from "../MarketPlacePricing/UnitPriceForm";
import IngramMappingPanel from "../MarketPlacePricing/IngramMappingPanel";
import DeleteDialog from "./DeleteDialog";
import { toast } from "react-toastify";
import PlanFormFields from "./PlanFormFields";
import FeaturesEditor from "./FeaturesEditor";

const initialValue = {
  name: "Your Product Name",
  description: "Product Description (around 40 words)",
  currency: "INR",
  tags: ["tag1", "tag2"],
  status: "Active",
  region: "GL",
  plan_highlight: ["highlight 1", "highlight 2", "highligh 3"],
  features: [],
  unit_ids: [],
  price_type: "price",
  plan_type: "recurring",
  trial_period_days: 0,
  modify_orders: "Prodata",
  unit_price_type: "Full",
  changed_unit_ids: false,
  allow_delete: true,
};

const initialContactValue = {
  name: "Contact Us",
  description: "Description for contact us",
  currency: "",
  tags: ["tag1", "tag2"],
  status: "Active",
  region: "GL",
  plan_highlight: ["highlight 1", "highlight 2", "highligh 3"],
  features: [],
  unit_ids: [],
  price_type: "contact",
  plan_type: "recurring",
  trial_period_days: 0,
  modify_orders: "Prodata",
  unit_price_type: "Full",
  changed_unit_ids: false,
  allow_delete: true,
};

function MarketPlaceT1({
  selected,
  planType,
  selectInterval,
  intervals,
  originalInterval,
  planErrors,
  setPlanErrors,
  featureErrors,
  setFeatureErrors,
  plans,
  originalPlan,
  setPlans,
  features,
  setFeatures,
  adminVendorId,
  productVendorId,
}) {
  const [selectedPlan, setSelectedPlan] = useState({});
  const [selectedType, setSelectedType] = useState(null);
  const [dropDownInterval, setDropDownInterval] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editingPlanId, setEditingPlanId] = useState(null);

  const isOwner = adminVendorId === productVendorId;

  // Plans
  const handleChange = (id, e) => {
    const { name, value } = e.target;
    setPlans((prev) =>
      prev.map((plan) => (plan.id === id ? { ...plan, [name]: value } : plan)),
    );
    setPlanErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [name]: false,
      },
    }));
  };
  const updatePlanUnitIds = (planId, unitIdsArray) => {
    setPlans((prev) =>
      prev.map((plan) =>
        plan.id === planId
          ? {
              ...plan,
              unit_ids: unitIdsArray,
              changed_unit_ids: unitIdsArray.some((u) => u.changed_unitprice),
            }
          : plan,
      ),
    );
  };
  const handleAddNewCard = () => {
    if (intervals.length === 0) {
      toast.error("Cannot add Plan, Add atleast one Interval");
      return;
    }
    const matchedInterval = intervals.find(
      (item) => item.index === selectInterval,
    );
    const planFeatures = features
      .filter((f) => f.typeId === selected)
      .map((f) => ({
        key: f.key,
        name: f.name,
        data: new Array(f.data.length).fill(""),
        typeId: selected,
      }));
    let obj = {
      ...initialValue,
      id: String(Date.now()) + "-" + Math.random().toString(36).slice(2),
      typeId: selected,
      interval: selectInterval,
      n_price_validity_interval: matchedInterval?.n_interval,
      price_validity_interval: matchedInterval?.interval,
      features: planFeatures,
    };
    setPlans((prev) => [...prev, obj]);
    setEditingPlanId(obj.id);
  };
  const handleAddContactCard = () => {
    if (intervals.length === 0) {
      toast.error("Cannot add Plan, Add atleast one Interval");
      return;
    }
    let obj = {
      ...initialContactValue,
      id: String(Date.now()) + "-" + Math.random().toString(36).slice(2),
      typeId: selected,
      interval: selectInterval,
    };
    setPlans((prev) => [...prev, obj]);
    setEditingPlanId(obj.id);
  };
  const handleCopyNewCard = () => {
    if (intervals.length === 0) {
      toast.error("Cannot add Plan, Add atleast one Interval");
      return;
    }
    if (Object.keys(selectedPlan).length) {
      const planFeatures = features
        .filter((f) => f.typeId === selected)
        .map((f) => ({
          key: f.key,
          name: f.name,
          data: new Array(f.data.length).fill(""),
          typeId: selected,
        }));
      const newId =
        String(Date.now()) + "-" + Math.random().toString(36).slice(2);
      setPlans((prev) => [
        ...prev,
        {
          ...selectedPlan,
          id: newId,
          name: `Copy of ${selectedPlan.name}`,
          typeId: selected,
          interval: selectInterval,
          features: planFeatures,
          allow_delete: true,
          plan_type: "recurring",
          unit_ids: (selectedPlan.unit_ids || []).map((u) => {
            const { id, ...rest } = u;
            return { ...rest };
          }),
        },
      ]);
      setSelectedPlan({});
      setEditingPlanId(newId);
    }
  };

  const handlRemoveCard = (product) => {
    setSelectedItem(product);
  };
  const duplicatePlan = (id) => {
    let newId = null;
    setPlans((prev) => {
      const index = prev.findIndex((plan) => plan.id === id);
      if (index === -1) return prev;
      const original = prev[index];
      newId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const copy = {
        ...JSON.parse(JSON.stringify(original)),
        id: newId,
        name: `Copy of ${original.name}`,
        allow_delete: true,
        unit_ids: (original.unit_ids || []).map((u) => {
          const { id, ...rest } = u;
          return { ...rest };
        }),
        // Strip featureValue ids from the cloned features. They belong to
        // the ORIGINAL plan's price_id in the DB; if we send them through
        // unchanged, the backend syncFeatureValues treats them as "existing
        // rows to update", finds no match for the new plan's price_id, and
        // silently drops the feature — leaving the duplicate with NO
        // featureValue rows in the DB. Stripping forces "create new" for
        // each feature so the duplicate gets its own DB rows.
        features: (original.features || []).map((f) => {
          const { id, ...rest } = f;
          return { ...rest };
        }),
      };

      const next = [...prev];
      next.splice(index + 1, 0, copy);
      return next;
    });
    if (newId) setEditingPlanId(newId);
  };

  const handleFHeadingChange = (e, key) => {
    const { value } = e.target;
    setFeatures((prev) =>
      prev.map((feature) =>
        feature.key === key ? { ...feature, name: value } : feature,
      ),
    );
    setPlans((prev) =>
      prev.map((plan) => ({
        ...plan,
        features: plan.features.map((d, i) =>
          d.key === key ? { ...d, name: value } : d,
        ),
      })),
    );
    setFeatureErrors((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        heading: false,
      },
    }));
  };

  const handleFTitleChange = (e, key, j) => {
    const { value } = e.target;
    setFeatures((prev) => {
      const index = prev.findIndex((f) => f.key === key);
      if (index === -1) return prev;

      const curr = [...prev];
      curr[index] = {
        ...curr[index],
        data: curr[index].data.map((d, di) => (di === j ? value : d)),
      };
      return curr;
    });
    setFeatureErrors((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        titles: prev[key]?.titles?.map((t, i) => (i === j ? false : t)),
      },
    }));
  };

  const handleFValueChange = (e, key, dataIndex, planId) => {
    const { value } = e.target;
    setPlans((prev) =>
      prev.map((plan) => {
        if (plan.id !== planId) return plan;

        const hasFeature = plan.features.some((f) => f.key === key);
        if (hasFeature) {
          return {
            ...plan,
            features: plan.features.map((feat) =>
              feat.key === key
                ? {
                    ...feat,
                    data: feat.data.map((d, dIdx) =>
                      dIdx === dataIndex ? value : d,
                    ),
                  }
                : feat,
            ),
          };
        }

        // Recovery path: this plan is missing the feature row entirely.
        // Happens for plans that were duplicated under the OLD bug
        // (cloned features carried the source's featureValue ids, backend
        // silently dropped them, plan persisted with zero featureValue
        // rows in DB). Synthesize the entry on first edit so the user can
        // recover by just typing the value — saves to DB on next save.
        const template = features.find((f) => f.key === key);
        if (!template) return plan;
        const len = Math.max((template.data || []).length, dataIndex + 1);
        const data = Array.from({ length: len }, (_, i) =>
          i === dataIndex ? value : "",
        );
        return {
          ...plan,
          features: [
            ...plan.features,
            {
              key: template.key,
              name: template.name,
              typeId: template.typeId,
              data,
            },
          ],
        };
      }),
    );
    setFeatureErrors((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        values: prev[key]?.values?.map((v, i) => (i === dataIndex ? false : v)),
      },
    }));
  };

  // Feature rows belong to a plan type. Every handler below must only touch
  // plans of the selected type — mapping over ALL plans inserted/removed
  // feature rows on plans of other types too, corrupting their features.
  const handleAddRow = (key) => {
    setPlans((prev) =>
      prev.map((plan) =>
        plan.typeId !== selected
          ? plan
          : {
              ...plan,
              features: plan.features.map((feat) =>
                feat.key === key ? { ...feat, data: [...feat.data, ""] } : feat,
              ),
            },
      ),
    );
    setFeatures((prev) =>
      prev.map((feat) =>
        feat.key === key ? { ...feat, data: [...feat.data, ""] } : feat,
      ),
    );
  };

  const handleAddHeading = () => {
    const newFeature = {
      key: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      name: "",
      data: [""],
      typeId: selected,
    };
    setPlans((prev) =>
      prev.map((plan) =>
        plan.typeId !== selected
          ? plan
          : {
              ...plan,
              features: [...plan.features, { ...newFeature }],
            },
      ),
    );
    setFeatures((prev) => [...prev, newFeature]);
  };

  const handleRemoveHeading = (key) => {
    setPlans((prev) =>
      prev.map((plan) =>
        plan.typeId !== selected
          ? plan
          : {
              ...plan,
              features: plan.features.filter((f, idx) => f.key !== key),
            },
      ),
    );
    setFeatures((prev) => prev.filter((f, idx) => f.key !== key));
  };

  const handleRemoveRow = (key, j) => {
    setPlans((prev) =>
      prev.map((plan) =>
        plan.typeId !== selected
          ? plan
          : {
              ...plan,
              features: plan.features.map((feat) =>
                feat.key === key
                  ? {
                      ...feat,
                      data: feat.data.filter((_, idx) => idx !== j),
                    }
                  : feat,
              ),
            },
      ),
    );
    setFeatures((prev) =>
      prev.map((feature) =>
        feature.key === key
          ? {
              ...feature,
              data: feature.data.filter((_, idx) => idx !== j),
            }
          : feature,
      ),
    );
  };

  const handleFDuplicate = (key) => {
    const newKey = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    setFeatures((prev) => {
      const index = prev.findIndex((f) => f.key === key);
      if (index === -1) return prev;
      const next = [...prev];
      const original = next[index];
      const copy = {
        ...original,
        id: String(Date.now()) + "-" + Math.random().toString(36).slice(2),
        key: newKey,
        name: `Copy Of ${original.name}`,
      };
      next.splice(index + 1, 0, copy);
      return next;
    });

    setPlans((prev) => {
      return prev.map((plan) => {
        const index = plan.features.findIndex((f) => f.key === key);
        if (index === -1) return plan;

        const features = plan.features;
        const original = features[index];
        const duplicate = {
          ...original,
          key: newKey,
          name: `Copy Of ${original.name}`,
        };
        return {
          ...plan,
          features: [
            ...features.slice(0, index + 1),
            duplicate,
            ...features.slice(index + 1),
          ],
        };
      });
    });
  };

  const editPlan =
    plans.find((p) => p.id === editingPlanId) || plans[0] || null;

  return (
    <>
      <div className={styles.priceEditorRoot}>
        {isOwner && (
          <div className={styles.planToolbar}>
            <button
              type="button"
              className={styles.toolbarPrimary}
              onClick={handleAddNewCard}
            >
              + New plan
            </button>
            <button
              type="button"
              className={styles.toolbarSecondary}
              onClick={handleAddContactCard}
            >
              + Contact-us plan
            </button>
            {originalPlan.length > 0 && (
              <div className={styles.copyFrom}>
                <span className={styles.copyFromLabel}>Copy from</span>
                <select
                  onChange={(e) => setSelectedType(Number(e.target.value))}
                  value={selectedType ?? ""}
                >
                  <option value="">Type</option>
                  {planType &&
                    planType.map((type, i) => (
                      <option value={i} key={i}>
                        {type.name}
                      </option>
                    ))}
                </select>
                <select
                  onChange={(e) => setDropDownInterval(Number(e.target.value))}
                  value={dropDownInterval ?? ""}
                >
                  <option value="">Interval</option>
                  {originalInterval &&
                    originalInterval
                      .filter((int) => int.typeId === selectedType)
                      .map((interval, i) => (
                        <option value={interval.index} key={i}>
                          {interval.interval}
                        </option>
                      ))}
                </select>
                <select
                  onChange={(e) => setSelectedPlan(JSON.parse(e.target.value))}
                  value={JSON.stringify(selectedPlan) ?? JSON.stringify({})}
                >
                  <option value={JSON.stringify({})}>Plan</option>
                  {originalPlan
                    .filter(
                      (item) =>
                        item.typeId === selectedType &&
                        item.interval === dropDownInterval,
                    )
                    .map((plan) => (
                      <option key={plan.id} value={JSON.stringify(plan)}>
                        {plan.name}
                      </option>
                    ))}
                </select>
                <button
                  type="button"
                  className={styles.toolbarSecondary}
                  onClick={handleCopyNewCard}
                >
                  Copy
                </button>
              </div>
            )}
          </div>
        )}

        {plans.length > 0 && (
          <div className={styles.planTabs}>
            {plans.map((p) => (
              <button
                key={p.id}
                type="button"
                className={`${styles.planTab} ${
                  editPlan?.id === p.id ? styles.planTabActive : ""
                }`}
                onClick={() => setEditingPlanId(p.id)}
              >
                {p.name || "Untitled plan"}
                {p.price_type === "contact" ? " · Contact" : ""}
              </button>
            ))}
          </div>
        )}

        {plans.length === 0 ? (
          <div className={styles.emptyPlans}>
            No plans yet for this type &amp; interval.
            {isOwner ? " Use “New plan” above to add one." : ""}
          </div>
        ) : (
          <PlanFormFields
            plan={editPlan}
            onChange={handleChange}
            disabled={!isOwner}
            template="recurring"
            planErrors={planErrors}
            allowDelete={editPlan?.allow_delete}
            onDuplicate={duplicatePlan}
            onDelete={handlRemoveCard}
            isOwner={isOwner}
          >
            <UnitPriceForm
              inline
              key={editPlan?.id}
              allow_delete={editPlan?.allow_delete}
              unitPrices={editPlan?.unit_ids || []}
              onSave={(updatedUnitPrices) =>
                updatePlanUnitIds(editPlan.id, updatedUnitPrices)
              }
              adminVendorId={adminVendorId}
              productVendorId={productVendorId}
              // Only pass a numeric id — unsaved / new plans use a random
              // string id and have no subscriptions to look up.
              priceId={
                editPlan?.id && /^\d+$/.test(String(editPlan.id))
                  ? editPlan.id
                  : null
              }
            />
          </PlanFormFields>
        )}

        {/* Ingram auto-fulfilment config for the selected LIVE plan (numeric
            price_id). Admin sets it for any product/plan directly. */}
        {editPlan && /^\d+$/.test(String(editPlan.id)) && (
          <IngramMappingPanel priceId={editPlan.id} skuId={editPlan.skuId} />
        )}

        <FeaturesEditor
          features={features}
          plans={plans}
          selected={selected}
          selectInterval={selectInterval}
          isOwner={isOwner}
          featureErrors={featureErrors}
          onHeadingChange={handleFHeadingChange}
          onTitleChange={handleFTitleChange}
          onValueChange={handleFValueChange}
          onAddRow={handleAddRow}
          onAddHeading={handleAddHeading}
          onRemoveHeading={handleRemoveHeading}
          onRemoveRow={handleRemoveRow}
          onDuplicate={handleFDuplicate}
        />
      </div>
      {/* Delete Dialog */}
      {selectedItem && (
        <DeleteDialog
          selectedItem={selectedItem}
          onClose={() => setSelectedItem(null)}
          setPlans={setPlans}
        />
      )}
    </>
  );
}

export default MarketPlaceT1;
